// extracted by mini-css-extract-plugin
module.exports = {"panel":"sgCPO","icon":"Ejoso"};